export default "__VITE_ASSET__C9Z_35b7__"